import { Empty } from 'antd';
import LoaderComponent from '../../../../../components/LoaderComponent';
import AllUserCard from './AllUserCard';

const AllUserList = ({
  userList,
  isEmptyOrderList,
  isFetchMoreOrderLoading,
  isEndUserLoading,
  infiniteScrollRef,
}) => (
  <div>
    {!isEmptyOrderList &&
      userList?.map((user) => (
        <AllUserCard
          infiniteScrollRef={infiniteScrollRef}
          key={user?.id}
          user={user}
        />
      ))}
    {(isFetchMoreOrderLoading || isEndUserLoading) && (
      <LoaderComponent size="small" setHeight={10} />
    )}
    {isEmptyOrderList && <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />}
  </div>
);

export default AllUserList;
